import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { Container, AdminContainer } from "./AdminStyles";
import { smartAPI } from "../../components/api/Smart";
import Navbar from "./Navbar";
import VacancyManagement from "./VacancyManagement";
import LoginForm from "./LoginForm";
import Messages from "./Messages";
import Applicants from "./Applicants";
import Cookies from "js-cookie"; // Import js-cookie

const Admin = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [vacancies, setVacancies] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [applications, setApplications] = useState([]);
  const [userName, setUserName] = useState("");
  const [activePage, setActivePage] = useState("vacaturebeheer");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handlePageChange = (page) => {
    setActivePage(page);
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setUserName("");
    Cookies.remove("authToken"); // Remove the cookie on logout
    Cookies.remove("username");
  };

  const onAddVacancy = (newVacancy) => {
    setVacancies([...vacancies, newVacancy]);
  };

  const handleLogin = (username, password) => {
    const loginData = { username, password };

    smartAPI(loginData, "POST", "login")
      .then((response) => {
        if (response.status === 200) {
          setIsLoggedIn(true);
          setUserName(response.data.username);
          Cookies.set("authToken", response.data.token, { expires: 1 });
          Cookies.set("username", response.data.username, { expires: 1 });
        } else {
          setMessage("De inloggegevens kloppen niet, probeer het opnieuw.");
        }
      })
      .catch((error) => {
        setMessage("De inloggegevens kloppen niet, probeer het opnieuw.");
      });
  };

  // Check if user is logged in when component mounts
  useEffect(() => {
    const token = Cookies.get("authToken"); // Retrieve token from cookies
    const storedUsername = Cookies.get("username"); // Retrieve username from cookies
    if (token && storedUsername) {
      setIsLoggedIn(true);
      setUserName(storedUsername); // Set the username from the cookie
    }
  }, []);

  // Fetch data only if logged in
  useEffect(() => {
    if (isLoggedIn) {
      const fetchVacancies = async () => {
        setLoading(true);

        try {
          const response = await smartAPI({}, "GET", "vacancies");
          if (response.status === 200) {
            setVacancies(response.data);
          } else {
            setMessage("There was an issue fetching vacancies.");
          }
        } catch (error) {
          setMessage("Error fetching vacancies. Please try again.");
        } finally {
          setLoading(false);
        }
      };

      const fetchContacts = async () => {
        setLoading(true);

        try {
          const response = await smartAPI({}, "GET", "contact");
          if (response.status === 200) {
            setContacts(response.data);
          } else {
            setMessage("There was an issue fetching contacts.");
          }
        } catch (error) {
          setMessage("Error fetching contacts. Please try again.");
        } finally {
          setLoading(false);
        }
      };

      const fetchApplications = async () => {
        setLoading(true);

        try {
          const response = await smartAPI({}, "GET", "apply");
          if (response.status === 200) {
            setApplications(response.data);
          } else {
            setMessage("There was an issue fetching applications.");
          }
        } catch (error) {
          setMessage("Error fetching applications. Please try again.");
        } finally {
          setLoading(false);
        }
      };

      fetchApplications();
      fetchVacancies();
      fetchContacts();
    }
  }, [isLoggedIn]);

  return (
    <Container>
      {!isLoggedIn ? (
        <LoginForm handleLogin={handleLogin} message={message} />
      ) : (
        <AdminContainer>
          <Navbar
            userName={userName}
            activePage={activePage}
            handlePageChange={handlePageChange}
            handleLogout={handleLogout}
          />
          {loading ? (
            <FontAwesomeIcon icon={faSpinner} spin size="2xl" />
          ) : (
            <>
              {activePage === "vacaturebeheer" && (
                <VacancyManagement
                  isLoggedIn={isLoggedIn}
                  vacancies={vacancies}
                  onAddVacancy={onAddVacancy}
                  setVacancies={setVacancies}
                />
              )}
              {activePage === "berichten" && (
                <Messages contacts={contacts} setContacts={setContacts} />
              )}
              {activePage === "sollicitaties" && (
                <Applicants applications={applications} />
              )}
            </>
          )}
        </AdminContainer>
      )}
    </Container>
  );
};

export default Admin;
